export default "__VITE_ASSET__KhhKS1AX__"